import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
    PatientSkillAcqActiveTargetListActionTypes, 
    GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_API,
    GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API,
    POST_PATIENT_SKILL_ACQ_COLLECT_DATA,
    GET_PATIENT_SKILL_ACQ_COLLECTED_Data_LIST_API,
    DELETE_PATIENT_SKILL_ACQ_COLLECTED_DATA,
    GET_PATIENT_SKILL_ACQ_TASK_ANALYSIS_LIST_API,
    DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API,
    GET_PATIENT_SKILL_ACQ_SELECTED_PROGRAMS_FOR_TARGET_API,
    GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_NEWFLOW_API,
    DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API_NEW_FLOW,
    GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API_NEW_FLOW,
    POST_PATIENT_SKILL_ACQ_COLLECT_FREQUENCY_DATA,
    POST_PATIENT_SKILL_ACQ_COLLECT_DURATION_DATA,
    GET_PATIENT_SKILL_ACQ_DOMAIN_PATIENT_ID ,
    GET_PATIENT_SKILL_ACQ_PROGRAM_DOMAIN_ID_PATIENT_ID,
    GET_PATIENT_SKILL_ACQ_TARGET_PROGRAM_PATIENT_ID,
    GET_MASTERDATABYNAME,
    GET_PATIENT_SKILL_ACQ_COLLECT_NEW_FLOW,
    GET_SKILL_ACQ_COLLECTEDDATA_BY_ID,

  } from '../constants/ApiConstants';
import Alert from 'react-s-alert';
import { reset } from 'redux-form';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../../../../../actions/utilAction';

export const PatientSkillAcqActiveTargetist = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetList.REQUEST));
        fetch(`${GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_API}${query_params}&includeMasteredTargetsOnly=false`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientSkillAcqActiveTargetList', error);
            });
    };
};

export const PatientSkillAcqActiveTargetListNewFlow = (searchObj) => {
  let query_params = createSearchUrlForCustomAPI(searchObj);
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetListNewFlow.REQUEST));
        fetch(`${GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_NEWFLOW_API}${query_params}&includeMasteredTargetsOnly=false`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetListNewFlow.SUCCESS, response));
                } else {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetListNewFlow.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientSkillAcqActiveTargetListNewFlow', error);
            });
    };
};

export const getPatientSkillAcqPreviousTrialistNewFlow = (patientId,sessionId, skillsAcquisitionTargetId) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.REQUEST));
      fetch(`${GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API_NEW_FLOW}?patientId=${patientId}&sessionId=${sessionId}&skillsAcquisitionTargetId=${skillsAcquisitionTargetId}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqPreviousTrialList', error);
          });
  };
};

export const getPatientSkillAcqPreviousTrialist = (patientId,sessionId, skillsAcquisitionTargetId) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.REQUEST));
      fetch(`${GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&skillsAcquisitionTargetId=${skillsAcquisitionTargetId}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqPreviousTrialList', error);
          });
  };
};

export const savePatientSkillsAcquisitionCollectedData = (authData, patientId,sessionId, skillsAcquisitionTargetId, targetType) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectData.REQUEST));
      fetch(`${POST_PATIENT_SKILL_ACQ_COLLECT_DATA}`, {
        method: 'POST',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        body: JSON.stringify(authData),
      })
        .then(checkHttpStatus)
        .then(function(response) {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectData.SUCCESS, response));
            if(targetType === 'DTT'){
              dispatch(getPatientSkillAcqPreviousTrialistNewFlow(patientId,sessionId, skillsAcquisitionTargetId))
              dispatch(reset('DTTModalForm'))
            } else {
              dispatch(reset('TaskAnalysisModalForm'))
            }
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectData.SUCCESS, null));
          }
        })
        .catch(function(error) {
          console.log('error post_patientSkillAcqCollectData', error);
        });
    };
  };

  export const getPatientSkillAcqCollectedData = (patientId,sessionId, sessionDate, targetType)  => {
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectedDataList.REQUEST));
        fetch(`${GET_PATIENT_SKILL_ACQ_COLLECTED_Data_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&sessionDate=${sessionDate}&targetType=${targetType}&includeMasteredTargetsOnly=false`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectedDataList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectedDataList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientSkillAcqCollectedDataList', error);
            });
    };
  };

  export const deletePatientSkillAcqCollectedData = (patientId,sessionId, sessionDate,collectedDataId, skillsAcquisitionTargetId, targetType) => {
    Alert.closeAll();
    return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.REQUEST));
      fetch(`${DELETE_PATIENT_SKILL_ACQ_COLLECTED_DATA}?collectedDataId=${collectedDataId}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then((response) => {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.SUCCESS, response));
            if(targetType === "DTT") {
              dispatch(getPatientSkillAcqCollectedData(patientId,sessionId, sessionDate, "DTT"));
              dispatch(getPatientSkillAcqPreviousTrialistNewFlow(patientId,sessionId, skillsAcquisitionTargetId));
            } else {
              dispatch(getPatientSkillAcqCollectedData(patientId,sessionId, sessionDate, "Task Analysis"));
            }
          } else if (response.statusCode === 401 || response.statusCode === 422) {
            showWarningMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.SUCCESS, null));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.SUCCESS, null));
          }
        }).catch(function(error) {
          console.log('error delete_patientSkillAcqCollectedData', error);
        });
    };
  };

  export const getPatientSkillAcqTaskAnalysislist = (patientId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTaskAnalysisList.REQUEST));
        fetch(`${GET_PATIENT_SKILL_ACQ_TASK_ANALYSIS_LIST_API}?patientId=${patientId}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTaskAnalysisList.SUCCESS, response));
                } else {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTaskAnalysisList.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientSkillAcqTaskAnalysisList', error);
            });
    };
  };

  export const deletePatientSkillAcqPreviousTrial= (collectedDataId,patientId,sessionId, skillsAcquisitionTargetId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.REQUEST));
      fetch(`${DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API}?collectedDataId=${collectedDataId}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then((response) => {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, response));
            dispatch(getPatientSkillAcqPreviousTrialist(patientId,sessionId, skillsAcquisitionTargetId))
          } else if (response.statusCode === 401 || response.statusCode === 422) {
            showWarningMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, null));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, null));
          }
        }).catch(function(error) {
          console.log('error delete_patientSkillAcqPrevTrial', error);
        });
    };
  };

  export const deletePatientSkillAcqPreviousTrial_NewFlow= (patientId,sessionId, sessionDate, skillsAcquisitionTargetId) => {
    Alert.closeAll();
    return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.REQUEST));
      fetch(`${DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API_NEW_FLOW}?patientId=${patientId}&sessionDate=${sessionDate}&skillAquisitionTargetId=${skillsAcquisitionTargetId}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then((response) => {
          if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
            showSuccessMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, response));
            dispatch(getPatientSkillAcqPreviousTrialistNewFlow(patientId,sessionId, skillsAcquisitionTargetId))
          } else if (response.statusCode === 401 || response.statusCode === 422) {
            showWarningMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, null));
          } else {
            showErrorMessage(response.message);
            dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, null));
          }
        }).catch(function(error) {
          console.log('error delete_patientSkillAcqPrevTrial', error);
        });
    };
  };

  
export const selectedProgramForTargetAction = (patientId, skillsAcquisitionProgramIds) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqSelectedProgramForTarget.REQUEST));
        fetch(`${GET_PATIENT_SKILL_ACQ_SELECTED_PROGRAMS_FOR_TARGET_API}?patientId=${patientId}&skillsAcquisitionProgramIds=${skillsAcquisitionProgramIds}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqSelectedProgramForTarget.SUCCESS, response));
                } else {
                    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqSelectedProgramForTarget.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_patientSkillAcqSelectedProgramForTarget', error);
            });
    };
};

export const SavePatientRecordFrequencyData = (formProps) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectFrequencyData.REQUEST));
      fetch(`${POST_PATIENT_SKILL_ACQ_COLLECT_FREQUENCY_DATA}`, {
          method: 'POST',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
          body: JSON.stringify(formProps),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  showSuccessMessage(response.message);
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectFrequencyData.SUCCESS, response));
              } else {
                  showErrorMessage(response.message);
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectFrequencyData.SUCCESS, null));
              }
          })
          .catch(function (error) {
              console.log('error post_patientSkillAcqCollectFrequencyData', error);
          });
  };
};

export const isRecordDurationRenderTrueSkAq = (flag) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.set_isRecordDurationRenderTrueSkAq.SUCCESS, flag));
  }
}

export const isRecordDurationStartSkAq = (index, flag) => { 
  return (dispatch, getState) => {
      let isStartDurationdata = getState().patientSkillAcqActiveTarget.isStartSkAq
      isStartDurationdata[index] = flag;
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.start_recordDurationTimerSkAq.SUCCESS, isStartDurationdata));
  }
}

export const customSecondsElapsedSkAq = (type, index) => {
  if(type === "mount") {
      console.log('inside mount');
      return (dispatch, getState) => {          
          let incrementerSkAq = getState().patientSkillAcqActiveTarget.incrementerSkAq
          incrementerSkAq[index] = setInterval(() => {
              let secondsElapsedSkAq = getState().patientSkillAcqActiveTarget.secondsElapsedSkAq
              secondsElapsedSkAq[index] = secondsElapsedSkAq[index] + 1
              dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.start_secondsElapsedSkAq.SUCCESS, secondsElapsedSkAq))
          }, 1000)
      }
  } else if (type === "unmount") {
      console.log('inside mount');
      return (dispatch, getState) => {
          let newIncrementerSkAq = getState().patientSkillAcqActiveTarget.newIncrementerSkAq
          newIncrementerSkAq[index] = setInterval(() => {
              let secondsElapsedSkAq = getState().patientSkillAcqActiveTarget.secondsElapsedSkAq
              secondsElapsedSkAq[index] = secondsElapsedSkAq[index] + 1
              dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.start_secondsElapsedSkAq.SUCCESS, secondsElapsedSkAq))
          }, 1000)
      }
  }
}

/* For stopwatch only  ends */


export const SavePatientRecordDurationData = (formProps) => {
  return (dispatch, getState) => {
      // dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectDurationData.REQUEST));
      fetch(`${POST_PATIENT_SKILL_ACQ_COLLECT_DURATION_DATA}`, {
          method: 'POST',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
          body: JSON.stringify(formProps),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  showSuccessMessage(response.message);
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectDurationData.SUCCESS, response));
              } else {
                  showErrorMessage(response.message);
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectDurationData.SUCCESS, null));
              }
          })
          .catch(function (error) {
              console.log('error post_patientSkillAcqCollectDurationData', error);
          });
  };
};

export const selectedProgramForPatientSkillAcqDomains = (patientId) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqDomainPatientId.REQUEST));
      fetch(`${ GET_PATIENT_SKILL_ACQ_DOMAIN_PATIENT_ID }?patientId=${patientId}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqDomainPatientId.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqDomainPatientId.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqDomainPatientId', error);
          });
  };
};
export const selectedProgramForPatientSkillAcqProgram= (patientId, skillsAcquisitionDomainId) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqProgramDomainIdPatientId.REQUEST));
      fetch(`${ GET_PATIENT_SKILL_ACQ_PROGRAM_DOMAIN_ID_PATIENT_ID }?patientId=${patientId}&skillsAcquisitionDomainId=${skillsAcquisitionDomainId}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqProgramDomainIdPatientId.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqProgramDomainIdPatientId.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqProgramDomainIdPatientId', error);
          });
  };
};
export const selectedProgramForPatientSkillAcqTarget= (patientId, skillsAcquisitionDomainId, skillsAcquisitionProgramId) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTargetPatientId.REQUEST));
      fetch(`${ GET_PATIENT_SKILL_ACQ_TARGET_PROGRAM_PATIENT_ID }?patientId=${patientId}&skillsAcquisitionDomainId=${skillsAcquisitionDomainId}&skillsAcquisitionProgramId=${skillsAcquisitionProgramId}&includeMasteredTargetsOnly=false`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTargetPatientId.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTargetPatientId.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqTargetPatientId', error);
          });
  };
};

export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_master_data.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        // console.log('response ....', response );
        dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_master_data.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('error getMasterData...', error);
      });
  };
};

export const get_patientSkillAcqCollectDataNewFlow = (data) => {
  // console.log(data, "get_patientSkillAcqCollectDataNewFlow")
  let query_params = createSearchUrlForCustomAPI(data.searchObj);
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlow.REQUEST));
      fetch(`${ GET_PATIENT_SKILL_ACQ_COLLECT_NEW_FLOW }${query_params}&patientId=${data.patientId}&domainId=${data.domainId}&sessionId=${data.sessionId}&sessionDate=${data.sessionDate}&targetType=${data.targetType}&programId=${data.programId}&targetId=${data.targetId}&includeMasteredTargetsOnly=${data.includeMasteredTargetsOnly}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlow.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlow.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqCollectDataNewFlow', error);
          });
  };
};

export const get_patientSkillAcqCollectDataNewFlowAfterEditing = (searchObj, data) => {
  //console.log(data, "get_patientSkillAcqCollectDataNewFlow")
  let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlow.REQUEST));
      fetch(`${ GET_PATIENT_SKILL_ACQ_COLLECT_NEW_FLOW }${query_params}&patientId=${data.patientId}&domainId=${data.domainId}&sessionId=${data.sessionId}&sessionDate=${data.sessionDate}&targetType=${data.targetType}&programId=${data.programId}&targetId=${data.targetId}&includeMasteredTargetsOnly=${data.includeMasteredTargetsOnly}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlow.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlow.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqCollectDataNewFlow', error);
          });
  };
};

export const getSkillAcqCollectedData = (patientId, collectedDataId,  targetType,searchObj) => {
  // console.log(patientId,collectedDataId, targetType, "parameter")
  // let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_skillAcqCollectedDataById.REQUEST));
      fetch(`${GET_SKILL_ACQ_COLLECTEDDATA_BY_ID}?patientId=${patientId}&collectedDataId=${collectedDataId}&targetType=${targetType}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_skillAcqCollectedDataById.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_skillAcqCollectedDataById.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_skillAcqCollectedDataById', error);
          });
  };
};

export const EnableTodayLabel = () => {
  return (dispatch) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.enable_todaysdata.SUCCESS, 0));
  }
}

export const DesableTodayLabel = () => {
  return (dispatch) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.desable_todaysdata.SUCCESS, 0));
  }
}

export const ResetList = () => {
  return (dispatch) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectDataNewFlowReset.SUCCESS, 0));
  }
}

export const setIsEventOccurePatientSkillAcqCollectDataNewFlowFalse = ()=>{
  return (dispatch) => {
    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.setIsEventOccurePatientSkillAcqCollectDataNewFlowFalse.SUCCESS));
  }
}

export const setCollapseMenuId = (id)=>{
  return (dispatch) => {
    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.setCollapseMenuId.SUCCESS,id));
  }
}   





// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/SkillAquisition/components/targets/actions/targetsActionNewFlow.js